export const INIT_LOADING_ELEMENTS ="INIT_LOADING_ELEMENTS"
export const END_LOADING_ELEMENTS = "END_LOADING_ELEMENTS"
export const LOAD_ELEMENTS = "LOAD_ELEMENTS"
export const ERROR = "ERROR"